import { PaginateList } from '../../../common/types/common-types';
import { CriteriaTypeEnum } from './criteria-setting';

export type ParameterItem = {
  _id: string;
  name: string;
  code: string;
  type: CriteriaTypeEnum;
  awards?: ParameterAward[];
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type ParameterPaginateList = PaginateList<ParameterItem> & {
  totalRecords: number;
  filter?: { updatedBy: string[] };
};

export type ParameterResultListParam = {
  name?: string;
  type?: string;
  code?: string;
  updatedBy?: string;
  updatedDateFrom?: Date | null;
  updatedDateTo?: Date | null;
  limit: number;
  page: number;
};

export enum CriteriaOperatorEnum {
  GREATER_THAN_EQUAL = '>=',
  SMALLER_THAN_EQUAL = '<=',
  GREATER = '>',
  SMALLER = '<',
  EQUAL = '=',
  NOT_EQUAL = '!=',
}

export type ParameterAwardCriteria = {
  keyId: string;
  operator: CriteriaOperatorEnum;
  value: string;
};

export type ParameterAwardRequirement = {
  name: string;
  // Logic - AND
  items: ParameterAwardCriteria[];
};

export type ParameterAward = {
  tier: number;
  tierCode: string;
  name: string;
  // Logic - OR
  requirements: ParameterAwardRequirement[];
};
